export enum WheelType {
  INITIAL = "",
  GIRLS = "girls",
  GIRLS_BANGLADESH = "girls-bangladesh",
  TEENAGERS = "teenagers",
  CARDS = "cards",
  AVIATOR = "aviator",
  CHICKS_TURKEY = "chicks-turkey",
  CHICKS_BANGLADESH = "chicks-bangladesh",
  CHICKS_UZBEKISTAN = "chicks-uzbekistan",
  CHICKS_AZER = "chicks-azerbaijan",
  CRAZY_TIME = "crazy-time",
  ROULETTE = "roulette",
  SWEET_BONANZA = "sweet-bonanza",
  GATES_OLYMPUS = "olympus",
  COIN_STRIKE = "coinStrike",
}

export type Prize = {
  id: number;
  title: string;
  angle: number;
};

export type BlockType = {
  id: number;
  logo: JSX.Element;
  title: string;
};

export type LogoType = {
  id: number;
  icon: JSX.Element;
};

export type WinText = {
  header: string;
  description: string;
  title: string;
  subtitle?: string;
  again: string;
  button: string;
};

export enum CountryLanding {}
